import { FC } from 'react';

import { LegalClientVersionEntity } from 'api/types/entity';
import { NavigationBreadcrumbsTitles } from 'components';
import { LayoutWithNavigationBreadcrumbs } from 'components/LayoutWithNavigationBreadcrumbs';
import { Form } from 'libs/form/Form';
import { getVersionDate } from 'modules/client/common/helpers';
import { VersionView } from 'modules/client/common/views';

import {
  LegalClientLegalHeadSectionsProps,
  LegalClientLegalHeadSections,
} from '../components';
import { LegalClientLegalHeadFormType } from '../forms/legalClientLegalHeadForm';

export interface LegalClientLegalHeadVersionViewProps
  extends LegalClientLegalHeadSectionsProps {
  breadcrumbsTitles: NavigationBreadcrumbsTitles;
  versions: LegalClientVersionEntity[];
  initialValues?: LegalClientLegalHeadFormType;
  fullName: string;
  versionId: string;
  error?: string;
  snapshotLoading?: boolean;
  onChangeVersion: (version: LegalClientVersionEntity) => void;
  onCloseVersionHistory: () => void;
}

export const LegalClientLegalHeadVersionView: FC<
  LegalClientLegalHeadVersionViewProps
> = ({
  breadcrumbsTitles,
  versions,
  fullName,
  initialValues,
  snapshotLoading,
  error,
  versionId,
  onCloseVersionHistory,
  onChangeVersion,
  ...sectionsProps
}) => (
  <LayoutWithNavigationBreadcrumbs titles={breadcrumbsTitles}>
    <VersionView
      content={
        initialValues && (
          <Form
            initialReadOnly
            initialShowCopyButton
            initialValues={initialValues}
            onSubmit={() => {}}
          >
            <LegalClientLegalHeadSections
              hideActivitySection
              countryRiskAt={getVersionDate(versions, versionId)}
              {...sectionsProps}
            />
          </Form>
        )
      }
      error={error}
      loading={snapshotLoading}
      name={fullName}
      versionId={versionId}
      versions={versions}
      onChangeVersion={onChangeVersion}
      onCloseVersionHistory={onCloseVersionHistory}
    />
  </LayoutWithNavigationBreadcrumbs>
);
